module.exports = __webpack_public_path__ + "img/menu3.11f153d6.png";